import { createContext, Dispatch, SetStateAction } from "react";
import {
  ArticleFilter,
  ArticleTable_ArticleFragment,
} from "../../../../__generated__/gql/graphql";
import { RowSelectionState } from "@tanstack/react-table";

type ArticleTableContextType = {
  visibleRows: ArticleTable_ArticleFragment[];
  filter?: ArticleFilter[];
  setRowSelection?: Dispatch<SetStateAction<RowSelectionState>>;
};

const ArticleTableContext = createContext<ArticleTableContextType>({
  visibleRows: [],
  filter: undefined,
  setRowSelection: undefined,
});

export default ArticleTableContext;
